import { ComponentType } from 'react';

import { RiToolsLine } from '@remixicon/react';

import { ModuleIcons } from '@spotify/confidence-core-react';

import { ToolGroupEntry } from '../../extensions/tool-extension';

export const DEFAULT_TOOL_ICON = RiToolsLine;

type IconComponent = ComponentType<{
  size?: number | string;
  style?: object;
  className?: string;
}>;

const TOOL_ICON_KEYWORDS: Array<{ keywords: string[]; icon: IconComponent }> = [
  {
    keywords: ['flag', 'targeting_rule'],
    icon: ModuleIcons.flags as IconComponent,
  },
  {
    keywords: ['abtest', 'ab_test', 'experiment'],
    icon: ModuleIcons.abtests as IconComponent,
  },
  {
    keywords: ['metric', 'measurement'],
    icon: ModuleIcons.metrics as IconComponent,
  },
  { keywords: ['segment'], icon: ModuleIcons.segments as IconComponent },
  { keywords: ['event'], icon: ModuleIcons.events as IconComponent },
  { keywords: ['rollout'], icon: ModuleIcons.rollouts as IconComponent },
  {
    keywords: ['analysis', 'analyze'],
    icon: ModuleIcons.analysis as IconComponent,
  },
  { keywords: ['surface'], icon: ModuleIcons.surfaces as IconComponent },
];

export const inferToolIcon = (toolName: string): IconComponent => {
  const lower = toolName.toLowerCase();
  const match = TOOL_ICON_KEYWORDS.find(({ keywords }) =>
    keywords.some(kw => lower.includes(kw)),
  );
  return match?.icon ?? DEFAULT_TOOL_ICON;
};

export const formatDefaultToolLabel = (
  entry: ToolGroupEntry,
): { text: string; detail?: string } => {
  return { text: entry.displayName ?? entry.tool.replace(/_/g, ' ') };
};
